export const employerHero = {
  title: "Hire from ranked matches — not resume floods",
  subtitle:
    "Post roles and soft-job engagements. CareerMaster surfaces people who fit — so your team reviews signal, not a stack of keyword hits.",
};

export const employerFeatures = [
  {
    title: "Ranked matches, not a candidate browse",
    body: "There is no open candidate search. The system presents people who fit the role you posted.",
  },
  {
    title: "Role and package fit",
    body: "Skills, preferences, location, and compensation context drive better introductions.",
  },
  {
    title: "FTE and contractor placement",
    body: "Algorithm-first matching for traditional hiring and contracting — without board noise.",
  },
  {
    title: "Soft jobs: discovery and modernization",
    body: "Post plain-language goals when the need is ambiguous. Match analysts who navigate discovery, modernization, and verified outcomes.",
  },
  {
    title: "Pipeline you can run",
    body: "Review matches, communicate, and move candidates through a clear hiring loop.",
  },
];

export const employerSteps = [
  {
    step: 1,
    title: "Register your hiring account",
    body: "Create an employer presence and set up who can recruit.",
  },
  {
    step: 2,
    title: "Post a role or soft job",
    body: "Define the opening — from a clear FTE/contractor role to a discovery or modernization engagement.",
  },
  {
    step: 3,
    title: "Review ranked matches",
    body: "See people the algorithm surfaces for fit — not a browse of the whole market.",
  },
  {
    step: 4,
    title: "Engage and hire",
    body: "Move forward with the right introductions, screening, and offers.",
  },
];
